document.addEventListener('DOMContentLoaded', () => {

  function ecAbrirModal(blockId, tipo) {
    const modal = document.getElementById(`ec-modal-${blockId}`);
    if (!modal) return;

    const paineis = modal.querySelectorAll('.ec-modal__painel');
    const controles = modal.querySelector('.ec-modal__controles');

    // Pausa todos os vídeos antes de mudar de painel
    modal.querySelectorAll('video').forEach(v => {
      v.pause();
      v.currentTime = 0;
    });

    paineis.forEach(p => {
      p.style.display = 'none';
    });

    const isVideo = tipo.includes('video');
    if (controles) controles.style.display = isVideo ? 'flex' : 'none';

    const painel = document.getElementById(`modal-${blockId}-${tipo}`);
    if (!painel) return;

    if (isVideo) {
      const src = painel.dataset.videoSrc;

      if (src && !painel.dataset.loaded) {
        // Detecta se é vídeo do YouTube/Vimeo ou local
        if (src.includes('youtube') || src.includes('youtu.be')) {
          painel.innerHTML = `
            <iframe 
              src="${src}?autoplay=1"
              class="ec-modal__midia"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowfullscreen>
            </iframe>
          `;
          if (controles) controles.style.display = 'none';
        } else {
          painel.innerHTML = `
            <video autoplay playsinline loop class="ec-modal__midia">
              <source src="${src}" type="video/mp4">
            </video>
          `;

          // Inicializa os ícones dos controles
          const btnMute = modal.querySelector('.ec-modal__btn-mute');
          const btnPause = modal.querySelector('.ec-modal__btn-pause');
          if (btnMute) {
            btnMute.querySelector('.ic-vol').style.display = '';
            btnMute.querySelector('.ic-mute').style.display = 'none';
          }
          if (btnPause) {
            btnPause.querySelector('.ic-pause').style.display = '';
            btnPause.querySelector('.ic-play').style.display = 'none';
          }
        }

        painel.dataset.loaded = "true";
      }
    }

    painel.style.display = 'block';
    modal.classList.add('ativo');
    document.documentElement.classList.add('ec-modal-aberto');
    
    if (isVideo) {
      // Busca o vídeo especificamente no painel que foi exibido
      const video = painel.querySelector('video');
      if (video) {
        setTimeout(() => {
          video.play().catch(err => console.log('Erro ao reproduzir:', err));
        }, 100);
      }
    }
  }

  function fecharModal(modal) {
    modal.classList.remove('ativo');
    document.documentElement.classList.remove('ec-modal-aberto');
    const controles = modal.querySelector('.ec-modal__controles');
    if (controles) controles.style.display = 'none';
    modal.querySelectorAll('video').forEach(v => v.pause());
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('.ec-modal__fechar')) {
      const modal = e.target.closest('.ec-modal');
      if (modal) fecharModal(modal);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('ec-modal')) {
      fecharModal(e.target);
    }
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.ec-modal__btn-mute');
    if (!btn) return;
    const modal = btn.closest('.ec-modal');
    const video = modal.querySelector('video');
    if (!video) return;

    video.muted = !video.muted;
    btn.querySelector('.ic-vol').style.display = video.muted ? 'none' : '';
    btn.querySelector('.ic-mute').style.display = video.muted ? '' : 'none';
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.ec-modal__btn-pause');
    if (!btn) return;
    const modal = btn.closest('.ec-modal');
    const video = modal.querySelector('video');
    if (!video) return;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }

    btn.querySelector('.ic-pause').style.display = video.paused ? 'none' : '';
    btn.querySelector('.ic-play').style.display = video.paused ? '' : 'none';
  });

  window.ecAbrirModal = ecAbrirModal;

});